import React from "react";

import IBK from "../resources/images/nftf/cardList/ibk.svg";
import MG from "../resources/images/nftf/cardList/mg.svg";
import Post from "../resources/images/nftf/cardList/post.svg";
import SC from "../resources/images/nftf/cardList/sc.svg";

// 002 광주
// 006 하나
import Hana from "../resources/images/nftf/cardList/hana.svg";
// 008 외환
// 010 전북
import JeunBuk from "../resources/images/nftf/cardList/jeunbuk.svg";
// 016 KB국민카드
import Kookmin from "../resources/images/nftf/cardList/kookmin.svg";
// 017 수협
// 018 NH농협
import NH from "../resources/images/nftf/cardList/nh.svg";
// 022 씨티
import Citi from "../resources/images/nftf/cardList/citi.svg";
// 026 비씨
import BC from "../resources/images/nftf/cardList/bc.svg";
// 027 현대카드
import Hyundai from "../resources/images/nftf/cardList/hyundai.svg";
// 028 JCB카드
// 029 신한카드
import ShinHan from "../resources/images/nftf/cardList/shinhan.svg";
// 031 삼성카드
import Samsung from "../resources/images/nftf/cardList/samsung.svg";
// 034 신세계(씨티)
// 045 롯데
import Lotte from "../resources/images/nftf/cardList/lotte.svg";
// 046 해외AMEX
// 047 우리카드
import Woori from "../resources/images/nftf/cardList/woori.svg";
// 048 해외다이너스
// 049 해외MASTER
// 050 해외VISA
// 090 케이뱅크
import Kbank from "../resources/images/nftf/cardList/kbank.svg";
// 091 카카오뱅크
import Kakao from "../resources/images/nftf/cardList/kakao.svg";

const CardIcon = (props) => {
  // props == cardInfo
  /*  
  {
    cardNm: <string>,
    cardNo: <string>,
    cardType: <string>,
    seqNo: <integer>
  }
  */

  const checkCardInfo = (cardCd) => {
    if (cardCd === "006") {
      return Hana;
    } else if (cardCd === "016") {
      return Kookmin;
    } else if (cardCd === "018") {
      return NH;
    } else if (cardCd === "022") {
      return Citi;
    } else if (cardCd === "026") {
      return BC;
    } else if (cardCd === "027") {
      return Hyundai;
    } else if (cardCd === "029") {
      return ShinHan;
    } else if (cardCd === "031") {
      return Samsung;
    } else if (cardCd === "045") {
      return Lotte;
    } else if (cardCd === "047") {
      return Woori;
    } else if (cardCd === "090") {
      return Kbank;
    } else if (cardCd === "091") {
      return Kakao;
    }
  };
  return <img src={checkCardInfo(props.cardInfo.cardCd)} />;
};

export const CardIconImg = (props) => {
  const checkCardInfo = (cardCd) => {
    if (cardCd === "006") {
      return Hana;
    } else if (cardCd === "016") {
      return Kookmin;
    } else if (cardCd === "018") {
      return NH;
    } else if (cardCd === "022") {
      return Citi;
    } else if (cardCd === "026") {
      return BC;
    } else if (cardCd === "027") {
      return Hyundai;
    } else if (cardCd === "029") {
      return ShinHan;
    } else if (cardCd === "031") {
      return Samsung;
    } else if (cardCd === "045") {
      return Lotte;
    } else if (cardCd === "047") {
      return Woori;
    } else if (cardCd === "090") {
      return Kbank;
    } else if (cardCd === "091") {
      return Kakao;
    }
  };

  return checkCardInfo(props.cardInfo.cardCd);
};

export default CardIcon;
